module.exports = "{{#if url}}\r\n    <a href=\"{{url}}\" class=\"popout-menu__txt\" title=\"{{getTitle}}\">{{name}}</a>\r\n{{else}}\r\n    <span class=\"popout-menu__txt\" title=\"{{getTitle}}\">{{name}}</span>\r\n{{/if}}";


//////////////////
// WEBPACK FOOTER
// ../src/dropdown/templates/menuItem.hbs
// module id = 652
// module chunks = 0